module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#logic",
      toString: function () {
        return this.url;
      }
    }